import { getJson } from "../../auth/utils/getJson.js";
import { apiFetch } from "../../auth/api/apiFetch.js"; 

/** GET /api/operators */
export function fetchOperators(signal) {
  return getJson("/api/operators", { signal });
}

/** PUT /api/operators/:code */
export async function updateOperatorName(code, newName, signal) {
  const res = await apiFetch(`/api/operators/${encodeURIComponent(code)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ Description: newName }),
    signal,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(
      json?.error || `updateOperatorName failed: ${res.status} ${res.statusText}`
    );
  return json;
}

/** POST /api/operators/refranchise */
export async function refranchiseOperator(payload, signal) {
  const res = await apiFetch("/api/operators/refranchise", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });

  const text = await res.text().catch(() => "");
  if (!res.ok) throw new Error(text || "refranchise failed");

  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}

/** GET /api/operators (Lite version) */
export function fetchOperatorsLite(signal) {
  return getJson("/api/operators", { signal }).then((data) =>
    Array.isArray(data)
      ? data.map((o) => ({ code: o.Code, name: o.Description }))
      : []
  );
}

/** GET /api/operators/checkcode?code=... */
export function checkOperatorCodeExists(code, signal) {
  return getJson(
    `/api/operators/checkcode?code=${encodeURIComponent(code)}`,
    { signal }
  );
}

/** POST /api/operators/create */
export async function createOperatorWithCode({ Description, Code }, signal) {
  const res = await apiFetch("/api/operators/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ Description, Code }),
    signal,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok)
    throw new Error(
      json?.error ||
        `createOperatorWithCode failed: ${res.status} ${res.statusText}`
    );
  return json;
}
